import { Route } from '~/routes/types';
import { INSIGHTS_ROUTE } from '~/routes/private/insights/constants';
import Insights from '~/pages/insights';

export const insights: Route = {
  to: INSIGHTS_ROUTE,
  exact: true,
  component: Insights
};
